import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminEntityListPage from "@/components/admin/admin-entity-list-page";

const AdminUsersListPage = (): JSX.Element => <AdminEntityListPage kind="users" />;

export const Route = createFileRoute("/_app/admin/users/")({
	component: AdminUsersListPage,
});
